import { render, staticRenderFns } from "./LargeTextCell.vue?vue&type=template&id=4a3f34dc&"
import script from "./LargeTextCell.vue?vue&type=script&lang=ts&"
export * from "./LargeTextCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports